import * as types from './types';

export const updateWishlist = (wishlist) => (dispatch) => (
  dispatch({
    type: types.LISTS_UPDATE_WISHLIST,
    wishlist
  })
);

export const addProductToList = (product) => (dispatch) => (
  dispatch({
    type: types.LISTS_ADD_PRODUCT_TO_LIST,
    product
  })
);

export const removeProductFromList = (product) => (dispatch) => (
  dispatch({
    type: types.LISTS_REMOVE_PRODUCT_FROM_LIST,
    product
  })
);
